<template>
    <div class="box-point-account bg-white max-w-2xl m-auto rounded-10 py-0 px-4 mt-3">
        <div class="border-b border-a-brown-f5ebdc py-3">
            <div class="flex justify-between items-center">
                <div class="flex items-center">
                    <div>
                        <img class="h-25px" src="../../../../../assets/profile_icon/language.svg">
                    </div>
                    <div class="ml-2 text-14 text-a-brown-502314">{{lbl.profile.language}}</div>
                </div>
                <div>
                    <SwitchLanguageBtn></SwitchLanguageBtn>
                </div>
            </div>
        </div>
        <ProfileMenuItem :menuTitle="lbl.profile.stores" url="/store">
            <img class="h-25px" src="../../../../../assets/profile_icon/store.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.contact_us" url="/contact">
            <img class="h-25px" src="../../../../../assets/profile_icon/contact-us.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.term_and_condition" url="/terms">
            <img class="h-25px" src="../../../../../assets/profile_icon/terms.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.privacy_statement" url="/privacy">
            <img class="h-25px" src="../../../../../assets/profile_icon/privacy.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.catering" url="/info/catering">
            <img class="h-25px" src="../../../../../assets/profile_icon/catering.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.fresh_taste" url="/info/freshtaste">
            <img class="h-25px" src="../../../../../assets/profile_icon/fresh-taste.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.made_to_order" url="/info/madetoorder">
            <img class="h-25px" src="../../../../../assets/profile_icon/made-to-order.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.promotion" url="/info/promotions" :noBorder="true">
            <img class="h-25px" src="../../../../../assets/profile_icon/promotion.svg">
        </ProfileMenuItem>
    </div>
</template>
<script>
import ProfileMenuItem from './ProfileMenuItem.vue'
import SwitchLanguageBtn from '@/components/Button/SwitchLanguageBtn.vue'
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    mixins: [LocaleMixin],
    components: {
        ProfileMenuItem,
        SwitchLanguageBtn,
    },
}
</script>
<style lang="scss" scoped>
</style>
